module.exports = __webpack_public_path__ + "img/[大兵].cf3c5109.svg";